<template>
  <RequestPricePlaceOrders
    ref="component"
    :period-id="periodId"
    @set-loader="$emit('set-loader', $event)"
    @subtitle="setSubtitle"
    @make-count-0="$emit('make-count-0')"
  />
</template>

<script>
import { setSubtitle } from '@/reusable/workflow/task-modals/modals-shared'
// Components
import RequestPricePlaceOrders from '../components/RequestPricePlaceOrders'

export default {
  components: {
    RequestPricePlaceOrders
  },

  props: {
    periodId: [Number, String]
  },

  methods: {
    setSubtitle: setSubtitle('Vendors'),

    getCount() {
      return this.$refs.component.getCount()
    }
  }
}
</script>
